
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 13.55q.5 0-1.35.137-.65.138-1.225.388-.425.2-.675.525-.25.325-.25.8zM17.375 21H6.625q-.7 0-1.162-.462Q5 20.075 5 19.375V4.625q0-.7.463-1.163Q5.925 3 6.625 3h6.95L19 8.425v10.95q0 .7-.462 1.163-.463.462-1.163.462zm0-1q.25 0 .437-.188.188-.187.188-.437V8.85L13.15 4H6.625q-.25 0-.437.188Q6 4.375 6 4.625v14.75q0 .25.188.437.187.188.437.188zM6 20V4v16z"}})])
          )
        }
      }
    